import { useState, useContext, useEffect } from "react"

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp';
import Button from '@mui/material/Button';
import { OptionsContext } from "../context/globalContext";
import { useNavigate } from "react-router-dom";
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { createOptions } from "../App";


export function Options({toggleOptions, gamemode}) {
    const [options, setOptions] = useState(JSON.parse(localStorage.getItem('options')))
    //const {optionsContext, setOptionsContext} = useContext(OptionsContext)

    const [guessTime, setGuessTime] = useState(null)
    const [numberOfSongs, setNumberOfSongs] = useState(null)
    const [numberOfLives, setNumberOfLives] = useState(null)
    const [defaultVolume, setDefaultVolume] = useState(null)

    const [checkedBranch, setCheckedBranch] = useState({
        en: true,
        id: true,
        jp: true
    });
    const [checkedSongType, setCheckedSongType] = useState({
        original: true,
        cover: false
    })

    useEffect(() => {
      try {
        setGuessTime(options.guessTime)
        setNumberOfSongs(options.numberOfSongs)
        setNumberOfLives(options.numberOfLives)
        setDefaultVolume(options.defaultVolume)
        setCheckedBranch({
            en: options.branches.en,
            id: options.branches.id,
            jp: options.branches.jp,
        })
        setCheckedSongType({
            original: options.songType.original,
            cover: options.songType.cover
        })
      } catch (error) {
        console.log(error)
        createOptions()
        setGuessTime(options.guessTime)
        setNumberOfSongs(options.numberOfSongs)
        setNumberOfLives(options.numberOfLives)
        setDefaultVolume(options.defaultVolume)
        setCheckedBranch({
            en: options.branches.en,
            id: options.branches.id,
            jp: options.branches.jp,
        })
        setCheckedSongType({
            original: options.songType.original,
            cover: options.songType.cover
        })
      }
    
    }, [])
    
    
    const handleChange = (event) => {
        setCheckedBranch({
          ...checkedBranch,
          [event.target.name]: event.target.checked,
        });
        setCheckedSongType({
          ...checkedSongType,
          [event.target.name]: event.target.checked,
        });
    };
    
    const { en, id, jp } = checkedBranch;
    const { original, cover } = checkedSongType;

    const navigate = useNavigate()

    function handleSave() {
        console.log(`guess: ${guessTime}, number: ${numberOfSongs}, volume: ${defaultVolume} `)

        setOptions({
            guessTime: guessTime,
            numberOfSongs: numberOfSongs,
            numberOfLives: numberOfLives,
            defaultVolume: defaultVolume,
            branches: checkedBranch,
            songType: checkedSongType
        })

        toggleOptions(false)
        //navigate('/')
    }

    useEffect(() => {
        console.log(options)

        localStorage.setItem('options', JSON.stringify(options))
    }, [options])

    

    return (
        <div className="options">
            <h1>Game Options</h1>
    
            {gamemode === 'standard' ? <div className="option">
                <p>Number of Songs: </p>
                <input type="text" value={numberOfSongs} onChange={(e) => setNumberOfSongs(e.target.value)}/>
            </div> : 
            gamemode === 'endless' ? <div className="option">
                <p>Number of Lives: </p>
                <input type="text" value={numberOfLives} onChange={(e) => setNumberOfLives(e.target.value)}/>
            </div> 
            : null
            }

            <div className="option">
                <p>Guess Time: </p>
                <input type="text" value={guessTime} onChange={(e) => setGuessTime(e.target.value)}/>
                <p className="seconds">seconds</p>
            </div>
            
            <div className="option flex-column">
                <p>Default Volume: </p>
                <Box sx={{ width: 330 }}>
                    <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                        <VolumeDown />
                        <Slider sx={{'color': 'white'}} aria-label="Volume" value={defaultVolume} onChange={(e) => setDefaultVolume(e.target.value)} />
                        <VolumeUp />
                    </Stack>
                </Box>
            </div>

            <div className="option flex-column">
                <p>Branches:</p>
                
                <FormGroup row={true}>
                    <FormControlLabel control={<Checkbox checked={en} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} name="en"/>} label="EN" />
                    <FormControlLabel control={<Checkbox checked={id} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} name="id"/>} label="ID" />
                    <FormControlLabel control={<Checkbox checked={jp} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} name="jp"/>} label="JP" />
                </FormGroup>
            </div>
            
            <div className="option flex-column">
                <p>Song Type:</p>
                
                <FormGroup row={true}>
                    <FormControlLabel control={<Checkbox checked={original} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} name="original"/>} label="Original" />
                    <FormControlLabel control={<Checkbox checked={cover} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} name="cover"/>} label="Cover" />
                </FormGroup>
            </div>

            <div className="save-btn">
                <Button className="save" variant="contained" onClick={() => handleSave()}>Save</Button>
            </div>
        </div>
    )
}